import React, { useEffect } from "react";
import { keycloak } from "../../../../lib/keycloak/index.ts";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hook.ts";
import { ButtonComponent } from "../../../../ui/molecules/button/index.tsx";
import { HeadingSize } from "../../../../ui/organisms/heading/dto.ts";
import { HeadingComponent } from "../../../../ui/organisms/heading/index.tsx";
import { Pagination } from "../../../../ui/organisms/pagination/index.tsx";
import { CompanyStatus } from "../../dto.ts";
import { AddDocumentsModal } from "../addDocumentsModal.tsx";
import { DocumentType } from "../dto.ts";
import { DocumentFilters } from "../filters.tsx";
import { findAllDocuments, setDocumentFilterPage, setOpenAddDocumentsModal } from "../slice.ts";
import { F24List } from "./list.tsx";

export function F24() {
    const dispatch = useAppDispatch()
    const documentState = useAppSelector(state => state.document)
    const companyState = useAppSelector(state => state.company)
    const authState = useAppSelector(state => state.auth)
    const layoutState = useAppSelector(state => state.layout)

    useEffect(() => {
        dispatch(findAllDocuments({ ...documentState.documentFilters, type: DocumentType.f24 }))
    }, [documentState.documentFilters.page])

    return (
        <div className="flex gap-3 flex-col flex-grow">
            <HeadingComponent
                label={"F24"}
                buttons={[
                    <>
                        {
                            !keycloak.hasRealmRole("company") && !keycloak.hasRealmRole("administrative_company") &&
                            <ButtonComponent
                                label="Aggiungi file"
                                size={"md"}
                                iconPosition={"off"}
                                variant={"solid"}
                                color={"blue"}
                                onClick={() => dispatch(setOpenAddDocumentsModal(true))}
                                disabled={companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED || (!authState.findMeFinancialAdvisorResponse?.isActive && keycloak.hasRealmRole("financial_advisor")) ||
                                    (!authState.findMeCollaboratorResponse?.isActive && keycloak.hasRealmRole("financial_advisor_collaborator"))
                                }
                            />
                        }
                    </>
                ]}
                size={HeadingSize.MD}
            />
            <DocumentFilters type={DocumentType.f24} />
            <div className="p-1 rounded-md relative">
                <F24List />
                {documentState.dragging && <div style={{ backgroundColor: layoutState.theme[400], pointerEvents: 'none' }} className=" absolute top-0 bottom-0 left-0 right-0 w-full z-20 opacity-50 rounded-2xl h-full ">
                </div>}
            </div>
            {
                documentState.findAllDocumentsResponse !== undefined &&
                documentState.findAllDocumentsResponse?.total > 0 &&
                <div className="flex bg-white drop-shadow-sm items-center justify-center p-2">
                    <Pagination
                        pages={documentState.findAllDocumentsResponse?.totalPage || 1}
                        currentPage={documentState.findAllDocumentsResponse.page}
                        setPage={(page) => dispatch(setDocumentFilterPage(page))}
                    />
                </div>
            }
            <AddDocumentsModal document={(keycloak.hasRealmRole('company') || keycloak.hasRealmRole('administrative_company')) ? "accountant" : "f24"} />
        </div>
    )
}